var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrainingBoardSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "training-board-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.613,
    height: 21.59,
    viewBox: "0 0 24.613 21.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23329",
    "data-name": "Path 23329",
    d: "M11.787,18.249a.449.449,0,0,1,.142-.09V16.278H.421a.421.421,0,1,1,0-.841H2.242V2.492H.421a.421.421,0,0,1,0-.841H11.863V.421a.421.421,0,0,1,.841,0v1.23H24.146a.421.421,0,1,1,0,.841H22.353V15.436h1.839a.421.421,0,1,1,0,.841H12.77V18.2a.419.419,0,0,1,.058.046l2.628,2.5a.419.419,0,0,1-.579.607l-2.107-2v1.819a.421.421,0,0,1-.841,0v-1.9L9.735,21.356a.419.419,0,0,1-.579-.607l2.63-2.5Zm9.725-2.812V2.492H3.083V15.436H21.512Z",
    fill: "#642d92",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingBoardSvgrepoCom);
export default __webpack_public_path__ + "static/media/training-board-svgrepo-com.06cc9206bd12d6a64a9c562b47a96252.svg";
export { ForwardRef as ReactComponent };